import CandidateSorOrder, { CandidateSortOrderProps } from './CandidateSortOrder.component';

export type CandidateSortOrderType = CandidateSortOrderProps;

export default CandidateSorOrder;
